import React, { useState, useEffect, Fragment } from "react"
import { makeStyles } from "@mui/styles"
import {
  CircularProgress,
} from "@mui/material"
import { useSnackbar } from "notistack"

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "90vh",
  },
  timedOut: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    width: "75%",
  },
  hidden: {
    visibility: "hidden",
  },
}))

export const Loading = (() => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [timedOut, setTimedOut] = useState(false)
  const timeoutDuration = 10000
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimedOut(true)
    }, timeoutDuration)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (timedOut) {
      enqueueSnackbar("This seems to be taking longer than usual. Please consider reloading page.", { variant: "error"})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timedOut])

  return (
    <div className={classes.container}>
      <CircularProgress />
    </div>
  )
})

const LoadingScreen = ({ isLoaded, children }) => {
  return (
    <Fragment>
      {isLoaded
        ? children
        : <Loading />
      }
    </Fragment>
  )
}

export default LoadingScreen
